import { useState } from "react";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";

import { newDateFormatter } from "../../utils/helpers";

const columns = [
	{ id: "S/N", label: "S/N", minWidth: 10 },
	{ id: "name", label: "Name", minWidth: 120 },
	{ id: "email", label: "Email", minWidth: 120 },
	{ id: "date", label: "Date", minWidth: 80 },
	{ id: "action", label: "Action", minWidth: 100 },
];

export default function StickyHeadTable({ tableData, loading }) {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Paper sx={{ width: "100%", overflow: "hidden", marginBottom: "3rem" }}>
			<TableContainer sx={{ maxHeight: 440 }}>
				<Table stickyHeader aria-label="sticky table">
					<TableHead
						sx={{
							backgroundColor: "#002564",
							"& .MuiTableHead-root": {
								backgroundColor: "black",
							},
						}}
					>
						<TableRow>
							{columns.map((column) => (
								<TableCell
									key={column.id}
									align={column.align}
									style={{ minWidth: column.minWidth }}
									sx={{
										backgroundColor: "primary.main",
										color: "white",
									}}
								>
									{column.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{!loading &&
							tableData
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((item, index) => (
									<TableRow key={item.id} hover role="checkbox" tabIndex={-1}>
										<TableCell>{page * rowsPerPage + index + 1}</TableCell>
										<TableCell>{`${item.firstname || ""} ${
											item.middlename || ""
										} ${item.lastname || ""}`}</TableCell>
										<TableCell>{item.email}</TableCell>
										<TableCell>{newDateFormatter(item.createdAt)}</TableCell>
										<TableCell>
											<Tooltip title="Click to view more details">
												<IconButton
													component={Link}
													to={`/admin/kyc-submission/view-request/${item.accountType}/${item.id}`}
												>
													<VisibilityIcon color="primary" />
												</IconButton>
											</Tooltip>
										</TableCell>
									</TableRow>
								))}
					</TableBody>
				</Table>
			</TableContainer>
			{loading && (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						width: "100%",
						marginTop: "2rem",
					}}
				>
					<CircularProgress size="2rem" />
				</Box>
			)}
			{!loading && tableData?.length === 0 && (
				<Box sx={{ textAlign: "center", marginTop: "2rem" }}>No data</Box>
			)}
			<TablePagination
				rowsPerPageOptions={[10, 25, 100]}
				component="div"
				count={tableData.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
}
